import axios from 'axios'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import socketIOClient from 'socket.io-client'
import {
  setAdminId,
  setShowFeedback,
  setUserDetails,
} from 'src/redux/reducer/commomReducer.js/commonReducer'
import { removeOfflineMessage } from 'src/redux/reducer/messageReducer.js/messageReducer'
import Chat from './UserChat'

const User = () => {
  const dispatch = useDispatch()
  const [socket, setSocket] = useState(null)
  const [listMessage, setListMessage] = useState([])
  // const [adminId, setAdminId] = useState('anonomyous')
  // const [online, setOnline] = useState(false)
  const [chatEnded, setChatEnded] = useState(false)
  const { showFeedback, adminId } = useSelector((state) => state.common)
  const [endChat, setEndChat] = useState(false)
  const [userId, setUserId] = useState(null)
  const [loggedIn, setLoggedIn] = useState(false)
  const [userPhno, setUserPhno] = useState('')
  const lastMessageTime = useRef(null)
  const intervalRef = useRef(null)
  const ref = useRef(null)
  const intervalRef2 = useRef(null)
  const ref2 = useRef(null)

  const sock = useRef(null)

  const storeRef = useRef(null)

  const automatedMessage = useRef(null)

  const { offlineMessageList } = useSelector((state) => state.message)

  const createSocketConnection = (token) => {
    const soc = socketIOClient(process.env.REACT_APP_BACKEND_URL, {
      query: `token=${token}`,
      transports: ['websocket'],
      forceNew: true,
    })
    setSocket(soc)
    sock.current = soc
  }

  const setLastMessageTime = (time) => {
    lastMessageTime.current = time
  }

  const getUserDetails = async (headers) => {
    try {
      const resp = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/user/getOneEndUser`, {
        headers: headers,
      })

      if (resp.data.data.assigned) {
        dispatch(setAdminId(resp.data.data.assignedBy))
      }
      dispatch(setUserDetails(resp.data.data))
      setEndChat(resp.data.data.endChat)
      setUserId(resp.data.data._id)
      setUserPhno(resp.data.data.phoneNumber)
    } catch (error) {
      console.log(error)
    }
  }

  const createMessage = async (request) => {
    try {
      if (localStorage.getItem('userId')) {
        const userData = JSON.parse(localStorage.getItem('userId'))
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userData.token}`,
        }

        const resp = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/message/create-message`,
          {
            to: request.to,
            from: request.from,
            message: request.message,
          },
          {
            headers: headers,
          },
        )
      }
    } catch (error) {
      console.log(error)
    }
  }

  const sendContinousMessage = (user, admin) => {
    const obj = {
      1:
        'You are currently in our queue, and a trained counsellor will connect with you soon. Thank you for your patience.' +
        '\n\n In the meantime, feel free to explore more details about our chat service here  https://icallhelpline.org/reyou-chat-line-faqs/',
      2:
        'It looks like all our counsellors are currently busy - we’re truly sorry for the wait. Please know that we’ve received your message and a counsellor will respond to your chat soon.' +
        '\nIn the meantime, if you’d like to explore other ways to connect with us or find immediate help, here are a few options:' +
        '\n\n \xa0  ■  ReYou Application ' +
        '\n 	\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0  1.	 Android: https://play.google.com/store/apps/details?id=org.codeb.IcallApp&pcampaignid=web_share' +
        '\n 	\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0  2.	 IOS: https://apps.apple.com/in/app/reyou-icalls-mental-health/id6738429307 ' +
        '\n\n \xa0  ■  Helpline: 9152987821' +
        '\n \xa0  ■  Email ID: icall@tiss.ac.in' +
        '\n \xa0  ■  Self-help resources:  https://icallhelpline.org/' +
        '\n\n If you wish to access in-person therapy, you can refer to our crowdsourced list of mental health professionals here:  https://docs.google.com/spreadsheets/d/1pzckT6ns2H1IlmwYwJa8EnBh_1u3gRA9cEOoA4zfilc/edit#gid=370032083 ',
    }

    let count = 1
    //!  internval for 5 second messages
    intervalRef2.current = setInterval(() => {
      let request
      if (automatedMessage.current || count === 2 || ref2.current === 'clear') {
        clearInterval(intervalRef2.current)
        return
      }

      if (lastMessageTime.current === null) {
        request = {
          message: obj[count],
          from: admin ? admin : adminId,
          to: user ? user : userId,
          createdAt: new Date(),
          state: true,
        }
        setListMessage((prev) => {
          return [...prev, request]
        })
        sock.current.emit('send-user', request)
        count++
      } else {
        if (new Date().getTime() / 1000 - lastMessageTime.current > 10) {
          request = {
            message: obj[count],
            from: admin ? admin : adminId,
            to: user ? user : userId,
            createdAt: new Date(),
            state: true,
          }
          setListMessage((prev) => {
            return [...prev, request]
          })
          sock.current.emit('send-user', request)
          count++
        }
      }
    }, [5000])

    //!  internval for 45 second messages
    intervalRef.current = setInterval(() => {
      let request
      if (automatedMessage.current || count === 3 || ref.current === 'clear') {
        clearInterval(intervalRef.current)
        return
      }

      if (lastMessageTime.current === null && count === 2) {
        request = {
          message: obj[count],
          from: admin ? admin : adminId,
          to: user ? user : userId,
          createdAt: new Date(),
          state: true,
        }
        setListMessage((prev) => {
          return [...prev, request]
        })
        sock.current.emit('send-user', request)
        count++
      } else {
        if (new Date().getTime() / 1000 - lastMessageTime.current > 10) {
          request = {
            message: obj[count],
            from: admin ? admin : adminId,
            to: user ? user : userId,
            createdAt: new Date(),
            state: true,
          }
          setListMessage((prev) => {
            return [...prev, request]
          })
          sock.current.emit('send-user', request)
          count++
        }
      }
    }, [50000])
  }

  useEffect(() => {
    if (localStorage.getItem('userId')) {
      const userData = JSON.parse(localStorage.getItem('userId'))
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userData.token}`,
      }
      getUserDetails(headers)
      createSocketConnection(userData.token)
    }

    return () => {
      ref.current = 'clear'
      clearInterval(intervalRef.current)
      clearInterval(intervalRef2.current)
    }
  }, [])

  useEffect(() => {
    storeRef.current = {
      offlineMessageList,
      adminId,
    }
  }, [offlineMessageList.length, adminId])

  useEffect(() => {
    automatedMessage.current = endChat
  }, [endChat])

  useEffect(() => {
    if (socket && userId) {
      socket.off('message').on('message', (data) => {
        if (Array.isArray(data)) {
          setListMessage(data)
        } else {
          setListMessage((prevState) => {
            const index = prevState.findIndex((e) => e.createdAt === data.createdAt)
            if (index != -1) {
              prevState.splice(index, 1)
            }
            return [...prevState, data]
          })
        }
        // setLastMessageTime(new Date().getTime() / 1000)
        if (data.from === userId || data.from === 'anonomyous') {
          setLastMessageTime(new Date().getTime() / 1000)
        } else {
          clearInterval(intervalRef.current)
          clearInterval(intervalRef2.current)
        }
      })
      socket.io.off('reconnect').on('reconnect', (attempt) => {
        const interval = setInterval(() => {
          if (socket.connected) {
            // socket.emit('get-all-user-messages', {
            //   messages: storeRef.current ? storeRef.current.offlineMessageList : null,
            //   adminId: storeRef.current ? storeRef.current.adminId : null,
            // })
            // storeRef.current = null
            clearInterval(interval)
            dispatch(removeOfflineMessage())
          }
        }, [100])
      })

      socket.off('user-assigned-to-admin').on('user-assigned-to-admin', (data) => {
        dispatch(setAdminId(data))
        setEndChat(false)
      })
      socket.off('user-chat-ended').on('user-chat-ended', (data) => {
        if (!data?.feedback) {
          dispatch(setShowFeedback(true))
        }
        automatedMessage.current = true
        setEndChat(true)
        setChatEnded(true)
      })
    }
  }, [socket, userId])

  return (
    <>
      <div style={{ bottom: 60, right: 10, width: '95%', height: '100%' }}>
        <Chat
          socket={socket}
          setListMessage={setListMessage}
          adminId={adminId}
          setAdminId={setAdminId}
          // online={online}
          // setOnline={setOnline}
          listMessage={listMessage}
          createSocketConnection={(token) => createSocketConnection(token)}
          createMessage={(request) => createMessage(request)}
          chatEnded={chatEnded}
          showFeedback={showFeedback}
          // setshowFeedback={setShowFeedback}
          setChatEnded={setChatEnded}
          loggedIn={loggedIn}
          setLoggedIn={setLoggedIn}
          userId={userId}
          setUserId={setUserId}
          userPhno={userPhno}
          setUserPhno={setUserPhno}
          endChat={endChat}
          setEndChat={setEndChat}
          intervalRef={intervalRef}
          intervalRef2={intervalRef2}
          setLastMessageTime={setLastMessageTime}
          sendContinousMessage={sendContinousMessage}
        />
      </div>
    </>
  )
}

export default User
